function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3336_167706)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 9H6C5.86739 9 5.74021 9.05268 5.64645 9.14645C5.55268 9.24021 5.5 9.36739 5.5 9.5V11H6.8335C6.96611 11 7.09329 11.0527 7.18705 11.1464C7.28082 11.2402 7.3335 11.3674 7.3335 11.5C7.3335 11.6326 7.28082 11.7598 7.18705 11.8536C7.09329 11.9473 6.96611 12 6.8335 12H5.5V13H6.8335C6.96611 13 7.09329 13.0527 7.18705 13.1464C7.28082 13.2402 7.3335 13.3674 7.3335 13.5C7.3335 13.6326 7.28082 13.7598 7.18705 13.8536C7.09329 13.9473 6.96611 14 6.8335 14H5.5C5.5 14.663 5.76339 15.2989 6.23223 15.7678C6.70107 16.2366 7.33696 16.5 8 16.5C8.66304 16.5 9.29893 16.2366 9.76777 15.7678C10.2366 15.2989 10.5 14.663 10.5 14V9.5C10.5 9.36739 10.4473 9.24021 10.3536 9.14645C10.2598 9.05268 10.1326 9 10 9Z",
  fill: "#FDFEFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.93 2.814C7.54049 2.11314 6.9708 1.52909 6.27986 1.12226C5.58891 0.715429 4.80182 0.500601 4 0.5C3.86739 0.5 3.74021 0.552678 3.64645 0.646447C3.55268 0.740215 3.5 0.867392 3.5 1C3.50124 1.95522 3.80595 2.88535 4.37014 3.65615C4.93434 4.42695 5.72884 4.99856 6.639 5.2885C6.84842 4.36602 7.2932 3.51351 7.93 2.814V2.814Z",
  fill: "#FDFEFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C10.8069 2.00132 9.66311 2.47585 8.81948 3.31948C7.97585 4.16311 7.50132 5.30693 7.5 6.5V8H8.5V6.972C9.5995 6.84775 10.6149 6.32328 11.3525 5.49855C12.0902 4.67382 12.4986 3.6065 12.5 2.5C12.5 2.36739 12.4473 2.24021 12.3536 2.14645C12.2598 2.05268 12.1326 2 12 2V2Z",
  fill: "#FDFEFF"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3336_167706"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(0 0.5)"
})));

function SvgLearning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/Learning.b9a17e96.svg";
export { ForwardRef as ReactComponent };